module.exports = __webpack_public_path__ + "img/stop_marker.82fb4cf2.svg";